import { render, staticRenderFns } from "./ConsultResponseV2Detail.vue?vue&type=template&id=77b1a716&scoped=true&"
import script from "./ConsultResponseV2Detail.vue?vue&type=script&lang=ts&"
export * from "./ConsultResponseV2Detail.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultResponseV2Detail.vue?vue&type=style&index=0&id=77b1a716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b1a716",
  null
  
)

export default component.exports